import { Button, DatePicker, Input, Radio, Space, Typography } from "antd";
import React, { useState } from "react";
import moment from "moment";

import { PROJECT_STATUSES } from "../../constants";

const { Search } = Input;
const { Text } = Typography;

const ProjectsToolbar = ({ filters, onFiltersChange, onAddProject }) => {
  const [searchKeyword, setSearchKeyword] = useState(
    filters.searchKeyword || ""
  );

  return (
    <>
      <Space
        style={{
          width: "100%",
          marginBottom: "1.25rem",
          justifyContent: "space-between",
        }}
        direction="horizontal"
        align="end"
        wrap
      >
        <Space wrap>
          <Radio.Group
            value={filters.status}
            buttonStyle="solid"
            onChange={(event) => {
              onFiltersChange("status", event.target.value);
            }}
          >
            <Radio.Button value="all">All</Radio.Button>
            <Radio.Button value={PROJECT_STATUSES.PENDING}>
              Pending
            </Radio.Button>
            <Radio.Button value={PROJECT_STATUSES.ONGOING}>
              Ongoing
            </Radio.Button>
            <Radio.Button value={PROJECT_STATUSES.COMPLETED}>
              Completed
            </Radio.Button>
            <Radio.Button value={PROJECT_STATUSES.OTHERS}>Others</Radio.Button>
            <Radio.Button value="archived">Archived</Radio.Button>
          </Radio.Group>
        </Space>
        <Space align="end" wrap>
          <>
            <Space direction="vertical">
              <Text>Start Date</Text>
              <DatePicker
                format="MM/DD/YYYY"
                value={filters.startDate}
                placeholder="Select start date"
                onChange={(value) => {
                  onFiltersChange("startDate", value);
                }}
                disabledDate={(current) => {
                  return moment().add(0, "days") < current;
                }}
              />
            </Space>
            <Space direction="vertical">
              <Text>End Date</Text>
              <DatePicker
                format="MM/DD/YYYY"
                value={filters.endDate}
                placeholder="Select end date"
                onChange={(value) => {
                  onFiltersChange("endDate", value);
                }}
                disabledDate={(current) => {
                  return (
                    moment().add(0, "days") < current ||
                    filters.startDate > current
                  );
                }}
              />
            </Space>
            <Space direction="vertical">
              <Text>Search Title</Text>
              <Search
                allowClear
                placeholder="Search"
                value={searchKeyword}
                onChange={(event) => setSearchKeyword(event.target.value)}
                onSearch={(value) => {
                  onFiltersChange("searchKeyword", value);
                }}
                enterButton
                style={{ width: "350px" }}
              />
            </Space>
          </>

          <Button type="primary" onClick={onAddProject}>
            Add Project
          </Button>
        </Space>
      </Space>
    </>
  );
};

export default ProjectsToolbar;
